module.exports = __webpack_public_path__ + "img/4.06df7127.jpg";